import { format as formatDate, isValid, parse } from 'date-fns';

const NOW = new Date(new Date().toDateString()); // remove time component

export const parseDate = (
  dateStr?: string,
  format = 'yyyy-MM-dd'
): Date | null => {
  if (!dateStr) {
    return null;
  }

  if (dateStr.endsWith('Z')) {
    return new Date(dateStr);
  }

  try {
    return parse(dateStr, format, NOW);
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const formatDateOrNull = (
  input: Date | string | null | undefined,
  outputFormat = 'yyyy-MM-dd',
  inputFormat = 'yyyy-MM-dd'
): string | null => {
  const date =
    typeof input !== 'string' ? input : parse(input, inputFormat, new Date());

  if (!date || !isValid(date)) {
    return null;
  }

  return formatDate(date, outputFormat);
};
